// Entry point (re-exports)
import './chat-widget.js'
export default window.ChatWidget
